import { Col, FormFeedback, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from "reactstrap";
import { FloatingInputGroup, FloatingInputGroupFeed } from "../../../../../Constant";
import { CommonFloatingFormGruopProp } from "../../../../../Type/CommonComponant";

const CommonFloatingFormGroup = ({ floatingLabel,inputClass,floatClass,invalid,required }: CommonFloatingFormGruopProp) => {
  return (
    <Row className="mb-3">
      <Label className="col-sm-3" check>{FloatingInputGroup}</Label>
      <Col sm="9">
        <InputGroup className={inputClass}>
          <InputGroupText>@</InputGroupText>
          <FormGroup floating className={floatClass}>
            <Input type="text" invalid={invalid} required={required} />
            <Label check>{floatingLabel}</Label>
          </FormGroup>
         <FormFeedback>{FloatingInputGroupFeed}</FormFeedback>
        </InputGroup>
      </Col>
    </Row>
  );
};

export default CommonFloatingFormGroup;
